<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { showModalStore } from "@retailer/svelte/stores/PreviewInfoModalStore";
  import { stagedRolloutCheck } from "@shared/svelte/Modules/StagedRolloutCheck.svelte";
  import docCookies from "@shared/services/cookies";
  export let salesRepPreview: boolean;

  let modalType: string = salesRepPreview ? "salesRepPreviewModal" : "previewModal";
  let showModal: boolean = $showModalStore;

  const close = () => {
    docCookies.setItem("previewModal", "1");
    showModalStore.update(n => false);
    showModal = false;
  };
</script>

<div class="fizz-styles">
  <Modal bind:show={showModal} fizzModal={true} size="medium" closeOnBackgroundClick={false}>
    <div class="layout-header-footer supplier-preview-modal" data-testid={modalType}>
      <header class="fizz-modal-header fizz-space-between fizz-align-content-start">
        <div class="fizz-flex-row fizz-align-content-start">
          <h4 class="fizz-heading-4 fizz-text-brand">
            You are now in Retailer preview mode on Provi.
          </h4>
        </div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div class="fizz-modal-toggle fizz-modal-close" on:click={close}>
          <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="16" width="16" />
        </div>
      </header>

      <section class="fizz-modal-main fizz-text-medium fizz-flow-16" data-grid-area="main">
        {#if salesRepPreview}
          Not all features are available in preview mode. Pricing and discounts are available only
          for the distributor you represent, and no other distributor pricing or discounts will be
          visible. Current product catalogs can be previewed, but are limited to the zip code of
          your distributor.
        {:else if salesRepPreview}
          Not all features are available while in preview mode, including pricing, deals, and stock
          information. Current product catalogs can be previewed, but are limited to the zip code of
          your distributor.
        {:else}
          Not all features are available while in preview mode, including pricing information.
          Sample advertising can be previewed but is limited to active campaigns and targeted ads
          for retailers by market.
        {/if}
      </section>

      <section class="fizz-modal-footer fizz-border-top fizz-flex-row fizz-justify-end">
        <button class="fizz-button-secondary" on:click={close}>Okay</button>
      </section>
    </div>
  </Modal>
</div>
